import { GradientColorStopObject } from 'highcharts';

type ConfigObj = {
  seriesName: string
  label: string,
  stops: GradientColorStopObject[]
  lineColor: string
  markerColor: string
};

const ChartBaseConfig = function ChartBaseConfig(configObj: ConfigObj, data: number[][], height = '200px') {
  const {
    stops, seriesName: name, lineColor, markerColor,
  } = configObj;
  const options = {
    chart: {
      zoomType: 'x',
      height,
      margin: [0, 0, 23, 0],
    },
    tooltip: {
      pointFormat: '<b>{point.y:.2f}</b><br>',
      shared: true,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: undefined,
    },
    subtitle: {
      text: undefined,
    },
    xAxis: {
      type: 'datetime',
    },
    yAxis: {
      visible: false,
    },
    legend: {
      enabled: false,
    },
    colors: [markerColor],
    plotOptions: {
      area: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops,
        },
        marker: {
          radius: 3,
          color: markerColor,
        },
        lineWidth: 1,
        states: {
          hover: {
            lineWidth: 1,
          },
        },
        threshold: null,
      },
    },
    series: [{
      type: 'area',
      name,
      data,
      lineColor,
    }],
  };
  return options;
};

export default ChartBaseConfig;
